import { NavLink } from 'react-router';

import { useLanguage } from '../../contexts/language';
import { useSession } from '../../contexts/session';

import { Initials } from '../initials';

import styles from './style.module.css';

// The desktop bar's way to Profile & settings: the signed-in person's name
// and initials at the far end, as drawn on the blueprint's top bar.
export function ProfileLink() {
  const { text } = useLanguage();
  const { me } = useSession();
  const { firstName, lastName } = me.profile;

  return (
    <NavLink className={ styles.link } to='/settings' aria-label={ text.profileAndSettings }>
      <span className={ styles.name }>{ `${ firstName } ${ lastName }` }</span>

      <Initials firstName={ firstName } lastName={ lastName }/>
    </NavLink>
  );
}
